const initialstate = {
  fetching: null,
  fetchingPagination: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  tree: [],
  emptyList: null,
  lastTime: null,
};

const getAllDiscoveryTreeReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'GETTING_ALL_DISCOVERY_TREE':
      return Object.assign({}, state, {
        fetching: true,
        fetchingPagination: false,
      });
    case 'GETTING_ALL_DISCOVERY_TREE_WITH_PAGINATION':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: true,
      });
    case 'GETTING_ALL_DISCOVERY_TREE_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingPagination: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        tree: action.payload.tree,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        emptyList: false,
      });
    // case 'UPDATE_USER_IN_ALL_USERS': {
    //   const index = state.participantsDetails.findIndex(
    //     ({ participation }) =>
    //       participation.id === action.payload.participationId,
    //   );
    //   let newArr = [...state.participantsDetails];
    //   if (newArr?.[index]?.participation !== undefined) {
    //     newArr[index]['participation'][action.payload.property] =
    //       action.payload.value;
    //   } else {
    //     newArr[index]['participation'][action.payload.property] =
    //       action.payload.value;
    //   }
    //   return Object.assign({}, state, {
    //     fetching: false,
    //     fetchingPagination: false,
    //     fetchingSuccessful: true,
    //     fetchingFailed: false,
    //     tree: newArr,
    //     lastTime: state.lastTime,
    //     emptyList: false,
    //     error: false,
    //     errorText: '',
    //   });
    // }
    case 'ADD_DISCOVERY_TREE_TO_ALL_DISCOVERY_TREE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingPagination: false,
        fetchingFailed: false,
        tree: Array.isArray(action.payload.tree)
          ? state.tree
            ? state.tree.concat(action.payload.tree)
            : action.payload.tree
          : state.tree,
        emptyList:
          Array.isArray(action.payload.tree) &&
          (action.payload.tree.length === 0 ||
            action.payload.tree.length % 15 > 0)
            ? true
            : false,
        lastTime: action.payload.lastTime
          ? action.payload.lastTime
          : state.lastTime,
        error: false,
        errorText: '',
      });
    case 'GETTING_ALL_DISCOVERY_TREE_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingFailed: true,
        fetchingPagination: false,
        error: true,
        errorText: action.payload,
        tree: [],
        emptyList: false,
        lastTime: '',
      });
    case 'GETTING_ALL_DISCOVERY_TREE_WITH_PAGINATION_FAILED':
      return Object.assign({}, state, {
        fetchingPagination: false,
      });
    default:
      return state;
  }
};

export default getAllDiscoveryTreeReducer;
